package com.perpheads.bans

enum class ScamPage {
    BANS, WARNINGS, BLACKLIST, LOGS, REPORTS, REPORT_LOGS, SCREENSHOTS, STATISTICS, ACCOUNT, DEMOS
}